import { gql } from 'graphql-tag';

export const GET_ACCOUNT_PAYABLE = gql`
  query Id5c5e9f73b5b4bbfe420447e6fd38168d($accountPayableId: ID!) {
    __typename
  }
`;
